import React, { useEffect, useContext, useRef } from 'react';
import videojs from 'video.js';
import "@silvermine/videojs-airplay/src/scss/videojs-airplay.scss";
import "@silvermine/videojs-chromecast/src/scss/videojs-chromecast.scss";
import '@videojs/http-streaming';
import 'video.js/dist/video-js.css';
import './PinkPlay/index.css';
import { AiOutlineClose } from "react-icons/ai";
import { VideoPlayerContext } from './VideoPlayerContext';
import { getGlobalAudio } from './Player';

// Import plugins
require('@silvermine/videojs-chromecast')(videojs, { preloadWebComponents: true });
require('@silvermine/videojs-airplay')(videojs);
require('@silvermine/videojs-quality-selector')(videojs);
require('@silvermine/videojs-quality-selector/dist/css/quality-selector.css');

const defaultSources = [
  { src: 'https://deams.xseu.net/MegaHit/index.m3u8', type: 'application/x-mpegURL', label: '1080P' },
  { src: 'https://deams.xseu.net/MegaHit_720p/index.m3u8', type: 'application/x-mpegURL', label: '720P' },
  { src: 'https://deams.xseu.net/MegaHit_360p/index.m3u8', type: 'application/x-mpegURL', label: '360P' },
];

const GlobalVideoPlayer = () => {
  const { 
    isAttached, 
    isClosed, 
    setIsClosed, 
    isPlaying, 
    setIsPlaying, 
    playerRef, 
    defaultContainerRef, 
    playerUI 
  } = useContext(VideoPlayerContext);

  useEffect(() => {
    // 1. Ensure the playerUI is inside the default container initially (or if detached)
    if (!isAttached && defaultContainerRef.current && playerUI) {
        defaultContainerRef.current.appendChild(playerUI);
    }

    // 2. Initialize VideoJS if not done
    if (!playerRef.current && playerUI) {
        if (playerUI.children.length === 0) {
            const videoWrapper = document.createElement('div');
            videoWrapper.setAttribute('data-vjs-player', 'true');
            // videoWrapper.style.width = '100%';
            // videoWrapper.style.height = '100%';

            const videoElement = document.createElement('video');
            videoElement.className = 'video-js vjs-theme-forest';
            videoElement.oncontextmenu = (e) => e.preventDefault();
            
            videoWrapper.appendChild(videoElement);
            playerUI.appendChild(videoWrapper);

            const videoJsOptions = {
                autoplay: false,
                controlBar: {
                  children: [
                     'playToggle',
                     'progressControl',
                     'volumePanel',
                     'qualitySelector',
                     'fullscreenToggle',
                  ],
               },
                plugins: {
                  airPlay: { addButtonToControlBar: true },
                  chromecast: {},
               },
                controls: true,
                fluid: true,
                muted: false,
                responsive: true,
                experimentalLLHLS: true,
                sources: defaultSources
              };
    
            const player = videojs(videoElement, videoJsOptions, () => {
                console.log('Global Player Ready');
            });
    
            playerRef.current = player;
            
            player.on('play', () => {
                console.log('GlobalPlayer: Play event');
                setIsPlaying(true);
                setIsClosed(false);
                const globalAudio = getGlobalAudio();
                if (globalAudio) {
                    globalAudio.pause();
                }
            });
            player.on('pause', () => {
                console.log('GlobalPlayer: Pause event');
                setIsPlaying(false)
            });
            player.on('error', (e) => console.error('GlobalPlayer: Error', e));
        }
    }

  }, []); 

  // Effect to handle moving the player back when detached
  useEffect(() => {
    console.log(`GlobalPlayer: isAttached changed to ${isAttached}`);
    if (!isAttached && defaultContainerRef.current && playerUI) {
        defaultContainerRef.current.appendChild(playerUI);
        
        // Safety check: if player is actually playing but state says otherwise
        if (playerRef.current && !playerRef.current.paused() && !isPlaying) {
             console.log('GlobalPlayer: Force setting isPlaying to true');
             setIsPlaying(true);
        }
    }
  }, [isAttached, playerUI]);


  const handleClose = () => {
    if (playerRef.current) {
        playerRef.current.pause();
        // Resetting the source effectively stops the live stream download
        // and prepares the player to start fresh when the user plays again.
        playerRef.current.src(defaultSources);
    }
    setIsClosed(true);
  };

  const shouldShow = !isAttached && isPlaying && !isClosed;
  console.log('GlobalPlayer Render: ', { isAttached, isPlaying, isClosed, shouldShow });

  const floatingStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '320px',
    height: '180px',
    zIndex: 9999,
    boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
    display: shouldShow ? 'block' : 'none',
    backgroundColor: '#000'
  };

  return (
    <div 
        ref={defaultContainerRef} 
        style={floatingStyle}
        className="global-player-floating-container"
    >
        {/* Close Button */}
        {!isAttached && (
            <div 
                onClick={handleClose} 
                style={{
                    position: 'absolute', 
                    top: '-15px', 
                    right: '-15px', 
                    background: 'red', 
                    borderRadius: '50%', 
                    width: '30px', 
                    height: '30px', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    cursor: 'pointer',
                    zIndex: 10000,
                    color: 'white'
                }}
            >
                <AiOutlineClose />
            </div>
        )}
        {/* Content is appended manually */}
    </div>
  );
};

export default GlobalVideoPlayer;
